export default __webpack_public_path__ + "images/30804-1-Moha-Leap-(274).jpg";